import { ERouteHttpVerb } from "@devowl-wp/api";
export const locationRestKeyValueMapPatch = {
    path: "/key-value-map/:name/:key",
    method: ERouteHttpVerb.PATCH
};
